module.exports = __webpack_public_path__ + "img/repedo.5b489de1.png";